module.exports = __webpack_public_path__ + "img/filigrana-1.d1df7ba2.png";